const validators = {
    email: (e) => {
        // eslint-disable-next-line
        let re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        return re.test(e);
    },
    cuit: (e) => {
        if(e.toString().length > 11){e = e.toString().substring(0, 11);}
        e = [...e].filter(e => isFinite(e)).join('');
        return e
    },
    number: (e) => {
        e = [...e].filter(e => isFinite(e)).join('');
        return e
    }
};

export default validators;


// WEBPACK FOOTER //
// ./src/utils/validators.js